export default "__VITE_ASSET__Cq8R6Ysz__"